import GrSlideItem1Component from './gr-slide-item-1';

export default GrSlideItem1Component;